module.exports = __webpack_public_path__ + "img/camion.e2ec306a.png";